<script setup>
import LocaleTabs from '@/components/Shared/Form/Input/LocaleTabs.vue';
import { reactive, ref, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { useLocales } from '@/composables/locales';
import FormInput from '@/components/Shared/Form/Input/Index.vue';
import { get } from 'lodash';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Object,
    default: {},
  },

  labelText: {
    type: String,
    default: '',
  },

  helpText: {
    type: String,
    default: '',
  },

  errors: {
    type: Object,
  },
  errorKey: {
    type: String,
    default: '',
  },

  containerClass: {
    type: String,
    default: '',
  },

  translatable: {
    type: Boolean,
    default: false,
  },
});

const page = usePage();

const locale = ref('en');
const value = reactive(props.modelValue?.en ? props.modelValue : { en: props.modelValue });
const locales = useLocales().locales;

watch(value, newValue => {
  emit('update:modelValue', newValue);
});
</script>

<template>
  <div :style="labelText ? 'margin-top: -45px' : ''">
    <locale-tabs :locales="locales" v-model="locale" :style="labelText ? 'position: relative; top: 45px' : ''" />
    <div v-for="(localeName, localeKey) in locales" :key="`form-input-${labelText}-${localeKey}`">
      <form-input
        v-show="localeKey === locale"
        :error="get(errors, `${errorKey}.${localeKey}`)"
        v-bind="{ ...$attrs, ...$props }"
        v-model="value[localeKey]"
      />
    </div>
  </div>
</template>
